import { useSelector } from "react-redux";
import { Navigate } from "react-router-dom";
import allRoutes from "client/constants/allRoutes";

/**
 * Route-level guard — the sidebar already hides links a role can't use, but
 * any authenticated user could previously still reach the page directly by
 * URL (browser history, a bookmark, typing it in). Backend endpoints were
 * already permission-checked, so this couldn't leak data, but the page would
 * render and its API calls would fail with 403s — confusing "error hi error"
 * screens for roles like Reception. This redirects before that happens.
 */
const PermissionRoute = ({ permission, element, adminOnly = false }) => {
  const permissions = useSelector((state) => state.auth.permissions) || [];
  const user = useSelector((state) => state.auth.user);

  const isAdminOrSuperAdmin = user?.RoleId === 1 || user?.RoleId === 2;
  // An array means "any of these", as checkPermission reads one on the backend.
  const anyOf = Array.isArray(permission) ? permission : [permission];
  // adminOnly: a page a permission must not be able to open, because the page changes what
  // permissions themselves are — role administration — or is kept for the Admin by the owner
  // (Tax Settings). The API refuses anyone else too (middleware/checkPermission
  // requireRoleAdministration; AdminSettingsController.updateSettings for the tax keys); this
  // only keeps staff from landing on a screen that would answer every save with "access denied".
  const allowed = isAdminOrSuperAdmin || (!adminOnly && anyOf.some((p) => permissions.includes(p)));

  if (!allowed) {
    return <Navigate to={allRoutes.portal} replace />;
  }

  return element;
};

export default PermissionRoute;
